module.exports = {"paymentTypeLabel":"tipo de pagamento","creditLabel":"Crédito","cardLabel":"Cartão","confirmBtn":"Confirmar a recarga","editDataBtn":"Editar dados"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/PaymentInfoCard/data.json
// module id = 1851
// module chunks = 0